/* eslint-disable */
const dataLayer = window.dataLayer || [];

dataLayer.manualLog = function(action = 'An unknown error has occurred.', category = 'ERROR') {
  dataLayer.push({
  'event' : "GALogger",
  'log-category' : category,
  'log-action' : action,
  'log-label' : "v=1.601",
  'log-value' : 1
  });
};

const handleErrorData = (err) => {
  let data = err.responseJSON.errorData[0];
  return {
    action: `[${data.param}] ${data.msg}`,
    category: 'ERROR'
  };
}

const handleSqlError = (err) => {
  let data = err.responseJSON.error;
  return {
    action: `[${data.errno}] ${data.code}`,
    category: 'ERROR'
  };
}

dataLayer.errorLog = function(err) {
  let errFunc = null;
  let errObj = null;
  if (err.syncStudentsError) {
    errObj = {
      category: 'ERROR',
      action: `[SYNC STUDENTS ERROR] ${err.message || err.responseText || err.statusText || 'Unknown error'}`
    }
  } else {
    if (err && err.responseJSON) {
      let json = err.responseJSON;
      if (json.errorData && json.errorData.length) {
        errFunc = handleErrorData;
      } else if (json.error) {
        if (json.error.sql) {
          errFunc = handleSqlError;
        } else {
          errObj = {
            category: 'ERROR',
            action: `[${json.error.code || 'ERROR'}] ${json.msg || json.error}`
          } 
        }
      }
    } else if (err.statusText) {
      errObj = {
        category: 'ERROR',
        action: `[${err.status}] ${err.statusText}`
      }
    } else {
      errObj = {
        category: 'ERROR',
        action: `[${err.status}] ${err.responseText}`
      }
    }
  }
  if (errFunc) {
    errObj = errFunc(err);
  } else if (errObj === null) {
    errObj = {
      category: 'ERROR',
      action: err.message || err.responseText || err.statusText || 'Unknown error'
    }
  }
  if (!errObj.action) errObj.action = err;
  dataLayer.push({
  'event' : "GALogger",
  'log-category' : errObj.category,
  'log-action' : errObj.action,
  'log-label' : "v=1.601",
  'log-value' : 1
  });
};

window.onerror = (...errors) => {
  const errorMessage = errors[0];
  const errorUrl = errors[1];
  const errorLine = errors[2];
  const errorColumn = errors[3] + 1;

  const lineString = isNaN(errorLine) ? '' : ` (line: ${errorLine}`;
  const columnString = isNaN(errorColumn) ? '' : `, column: ${errorColumn})`;
  const errorEvent = `[${errorMessage}][${errorUrl}${lineString}${columnString}]`;
  if (dataLayer) {
    dataLayer.push({
      'event' : "GALogger",
      'log-category' : "JSERROR",
      'log-action' : errorEvent,
      'log-label' : "v=1.601",
      'log-value' : 1
    });
  }
  return errors; // make true to hide errors
};

// dataLayer.push({
// 'event' : "GALogger", //never changes
// 'log-category' : "DEBUG, LOG, INFO, WARN, ERROR, CRITICAL, JSERROR", //must be only 1 of those
// 'log-action' : "This is the actual js error text including any needed information",
// 'log-label' : "v=1.585", //this is the version, in this exact format
// 'log-value' : 1 //number only, also optional
// });
